import { showErrorMessage } from "../../Helpers/ErrorMessages";
import {
  ApiAddCustomParameter,
  ApiDeleteAssessmentbyId,
  ApiDeleteStakingRiskCategory,
  ApiDeleteStakingRiskProductByID,
  ApiDeleteStakingRiskProducts,
  ApiGetStakingRiskAssessments,
  ApiGetStakingRiskClassifications,
  ApiGetStakingRiskProductByID,
  ApiGetStakingRiskProducts,
  ApiUpdateAssessmentbyId,
  ApiUpdateClassificationbyId,
  ApiUpdateStakingRiskProduct,
  createStakingRiskCategoryProduct,
  createStakingRiskProduct,
  dublicateStakingRiskProduct,
  GetAllDeletedStakingRiskProducts,
} from "../../Services";
import {
  STAKING_RISK_ASSESSMENT_UPDATE_BY_ID,
  STAKING_RISK_ASSESSMENT_UPDATE_BY_ID_ERROR,
  STAKING_RISK_ASSESSMENTBYID_DELETE,
  STAKING_RISK_ASSESSMENTS,
  STAKING_RISK_BY_ID,
  STAKING_RISK_CATEGORY_DELETE,
  STAKING_RISK_CLASSIFICATION_UPDATE_BY_ID,
  STAKING_RISK_CLASSIFICATION_UPDATE_BY_ID_ERROR,
  STAKING_RISK_CLASSIFICATIONS,
  STAKING_RISK_CREATING,
  STAKING_RISK_CREATING_CATEGORY,
  STAKING_RISK_CUSTOM_PARAMETER_CREATING,
  STAKING_RISK_CUSTOM_PARAMETER_ERROR,
  STAKING_RISK_DELETE,
  STAKING_RISK_DELETED_LIST,
  STAKING_RISK_DUBLICATE,
  STAKING_RISK_DUBLICATE_ERROR,
  STAKING_RISK_ERROR,
  STAKING_RISK_LIST,
  STAKING_RISK_NAME_UPDATE,
  STAKING_RISK_PRODUCTS_DELETE_OR_RESTORE,
} from "../Reducers/StakingRiskReducer";

export function GetStakingRiskProductsThunk(param = null) {
  return (dispatch) => {
    ApiGetStakingRiskProducts(param).then((result) => {
      dispatch({
        type: STAKING_RISK_LIST,
        payload: {
          result: result.data.data,
        },
      });
    });
  };
}
export function GetStakingRiskAssessmentsThunk(param = null) {
  return (dispatch) => {
    ApiGetStakingRiskAssessments(param).then((result) => {
      dispatch({
        type: STAKING_RISK_ASSESSMENTS,
        payload: {
          result: result.data.data,
        },
      });
    });
  };
}

export function GetStakingRiskClassificationsThunk(param = null) {
  return (dispatch) => {
    ApiGetStakingRiskClassifications(param).then((result) => {
      dispatch({
        type: STAKING_RISK_CLASSIFICATIONS,
        payload: {
          result: result?.data?.data,
        },
      });
    });
  };
}
export function GetStakingRiskProductByIDThunk(id) {
  return (dispatch) => {
    ApiGetStakingRiskProductByID(id).then((result) => {
      dispatch({
        type: STAKING_RISK_BY_ID,
        payload: {
          result: result.data.data,
        },
      });
    });
  };
}

export function CreateStakingRiskThunk(data) {
  return (dispatch) => {
    createStakingRiskProduct(data)
      .then((result) =>
        dispatch({
          type: STAKING_RISK_CREATING,
          payload: {
            result: result?.data.data,
          },
        }),
      )
      .catch((e) => {
        return dispatch({
          type: STAKING_RISK_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      });
  };
}
export function CreateStakingRiskCategoryThunk(data) {
  return (dispatch) => {
    createStakingRiskCategoryProduct(data)
      .then((result) =>
        dispatch({
          type: STAKING_RISK_CREATING_CATEGORY,
          payload: {
            result: result?.data.data,
          },
        }),
      )
      .catch((e) => {
        return dispatch({
          type: STAKING_RISK_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      });
  };
}

export function DublicateStakingRiskThunk(id) {
  return (dispatch) => {
    dublicateStakingRiskProduct(id)
      .then((result) =>
        dispatch({
          type: STAKING_RISK_DUBLICATE,
          payload: {
            result: result?.data.data,
          },
        }),
      )
      .catch((e) => {
        return dispatch({
          type: STAKING_RISK_DUBLICATE_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      });
  };
}

export function UpdateStakingRiskProductThunk(data, id, onSuccess) {
  return (dispatch) => {
    ApiUpdateStakingRiskProduct(data, id)
      .then(() => {        
        onSuccess?.();
        dispatch({
          type: STAKING_RISK_NAME_UPDATE,
        });
      })
      .catch((e) => {
        showErrorMessage(e?.response?.data?.error?.message?.[0]);
        return dispatch({
          type: STAKING_RISK_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      });
  };
}

export function DeleteStakingRiskProductByIDThunk(id, type = null) {
  return (dispatch) => {
    ApiDeleteStakingRiskProductByID(id, type).then((e) =>
      dispatch({
        type: STAKING_RISK_DELETE,
      }),
    );
  };
}
export function DeleteStakingRiskCategoryByIDThunk(id) {
  return (dispatch) => {
    ApiDeleteStakingRiskCategory(id).then((e) =>
      dispatch({
        type: STAKING_RISK_CATEGORY_DELETE,
      }),
    );
  };
}

export function UpdateAssessmentByIdThunk(id, scoreLevel, comment, name) {
  return (dispatch) => {
    ApiUpdateAssessmentbyId(id, scoreLevel, comment, name)
      .then((e) =>
        dispatch({
          type: STAKING_RISK_ASSESSMENT_UPDATE_BY_ID,
        }),
      )
      .catch((e) => {
        return dispatch({
          type: STAKING_RISK_ASSESSMENT_UPDATE_BY_ID_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      });
  };
}

export function UpdateClassificationByIdThunk(id, data) {
  return (dispatch) => {
    ApiUpdateClassificationbyId(id, data)
      .then((e) =>
        dispatch({
          type: STAKING_RISK_CLASSIFICATION_UPDATE_BY_ID,
        }),
      )
      .catch((e) => {
        return dispatch({
          type: STAKING_RISK_CLASSIFICATION_UPDATE_BY_ID_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      });
  };
}
export function DeleteAssessmentbyIdThunk(id) {
  return (dispatch) => {
    ApiDeleteAssessmentbyId(id).then((e) =>
      dispatch({
        type: STAKING_RISK_ASSESSMENTBYID_DELETE,
      }),
    );
  };
}

export function AddCustomParameterThunk(data) {
  return (dispatch) => {
    ApiAddCustomParameter(data)
      .then((result) =>
        dispatch({
          type: STAKING_RISK_CUSTOM_PARAMETER_CREATING,
          payload: {
            result: result?.data.data,
          },
        }),
      )
      .catch((e) => {
        return dispatch({
          type: STAKING_RISK_CUSTOM_PARAMETER_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      });
  };
}
export function GetAllDeletedStakingRiskProductsThunk(id) {
  return (dispatch) => {
    GetAllDeletedStakingRiskProducts(id).then((result) =>
      dispatch({
        type: STAKING_RISK_DELETED_LIST,
        payload: {
          result: result?.data.data,
        },
      }),
    );
  };
}

export function DeleteOrRestoreStakingRiskProductThunk(type) {
  return (dispatch) => {
    ApiDeleteStakingRiskProducts(type).then((e) =>
      dispatch({
        type: STAKING_RISK_PRODUCTS_DELETE_OR_RESTORE,
      }),
    );
  };
}
